var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5_49",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 14,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0H18V11.3671H4V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5_49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.15407 11.0587L13.9507 6.2654C14.2833 5.9328 14.2833 5.386 13.9507 5.0534L9.15407 0.249242C8.82147 -0.0830807 8.27411 -0.0830807 7.94151 0.249242C7.60891 0.581844 7.60891 1.12864 7.94151 1.46096L11.2787 4.7962H-9.14155C-9.61378 4.7962 -10 5.18214 -10 5.65409C-10 6.12577 -9.61378 6.51199 -9.14155 6.51199H11.2681L7.9309 9.84694C7.75915 10.0187 7.68403 10.2332 7.68403 10.4583C7.68403 10.6833 7.76977 10.8978 7.9309 11.0696C8.27411 11.3913 8.82147 11.3913 9.15407 11.0587Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.66258aedfb4febf9b278aa725033dc52.svg";
export { ForwardRef as ReactComponent };